module.exports = __webpack_public_path__ + "img/8.b5a3d189.png";